import React from 'react'
import Tag from 'antd/es/tag'
import IdeyaTypography from '@/common/antd/ideya-typography.tsx'
import { themeConstants } from '@/styles/theme-constants.ts'
import { rankTagText } from './ranking-card.types.ts'

interface RankTagProps {
  rank: number | null
  rankTotal: number
  // Self rows use the primary brand border; everyone else keeps the neutral one.
  isSelf?: boolean
}

// The shared "rank/total" pill, used by both the desktop table and the mobile
// card view so the badge stays visually identical across both.
export const RankTag: React.FC<RankTagProps> = React.memo(
  ({ rank, rankTotal, isSelf = false }) => (
    <Tag
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        margin: 0,
        padding: `1px ${themeConstants.sizeXS}`,
        borderRadius: 20,
        borderColor: isSelf
          ? 'var(--color-primary-border)'
          : 'var(--color-border)',
        backgroundColor: 'var(--card-more-bg)',
        fontVariantNumeric: 'tabular-nums',
        // antd Tag defaults to `transition: all`, which lags the tag's
        // fade/border during the fly-to-row show/hide swap.
        transition: 'none',
      }}
    >
      <IdeyaTypography.Text size={'sm'}>
        {rankTagText(rank, rankTotal)}
      </IdeyaTypography.Text>
    </Tag>
  )
)
